// 模型覆盖

import { RootObject, Datum } from '../../type';
import './style.less';


const ModelCovering = (props: RootObject["modelCovering"]) => {

  return (
    <div className="model_covering">
      <div className="model_covering_title">
        {props.title ?? ""}
      </div>
      <div className="model_covering_table">
        <div className="table_header">
          <div className="table_tr_th">
           {props.imageClassificationTitle ?? ""}
          </div>
          <div className="table_tr_th">
            {props.targetDetectionTitle ?? ""}
          </div>
          <div className="table_tr_th">
            {props.ocrTitle ?? ""}
          </div>
          <div className="table_tr_th">
            {props.imageSegmentationTitle ?? ""}
          </div>
        </div>

        {
          props.data.map((value: Datum, index: number) => {
            return (
              <div className="table_body" key={index}>
                <div className="table_tr_td">
                  {
                    value.imageClassification.columnOne ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.imageClassification.columnTwo ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.targetDetection.columnOne ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.targetDetection.columnTwo ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.targetDetection.columnThree ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.ocr.columnOne ?? ""
                  }
                </div>
                <div className="table_tr_td">
                  {
                    value.imageSegmentation.columnOne ?? ""
                  }
                </div>
              </div>
            )
          })
        }


      </div>
    </div>
  )
}

export default ModelCovering;